import React, {useCallback} from 'react';
import {useDropzone} from 'react-dropzone';

function FileUploader(props) {
    const {accept = '.csv', handleUploadedFiles} = props;

    const onDropAccepted = useCallback((acceptedFiles) => {
        handleUploadedFiles(acceptedFiles);
    }, []);

    const {getRootProps, getInputProps, fileRejections, isDragReject} = useDropzone({onDropAccepted, accept});

    let message;
    if (!isEmpty(fileRejections)) {
        message = <p>Only CSV extension is allowed.</p>;
    }

    return (
        <section className="dropzone-container">
            <div {...getRootProps({className: 'dropzone'})} data-testid="late-swap-dropzone">
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <aside>{message}</aside>
        </section>
    );
}

export {FileUploader};
